export const projectsData = [
  {
    id: 7,
    name: "Giftseeker",
    imgUrl:
      "Images/giftseeker.png",
    info: "An app to find best gifts for every occasion",
    github: "https://github.com/Dev-kunal/gifty",
    live: "https://www.giftseeker.in/",
  },
  {
    id: 6,
    name: "Game of Life",
    imgUrl:
      "https://ik.imagekit.io/abcdefg/ProjectImages/Screenshot%202024-08-07%20at%201.58.02%E2%80%AFPM_HBwlwXoQK.png?updatedAt=1723019294674",
    info: "Conway's Game of Life",
    github: "https://github.com/Dev-kunal/GameOfLife",
    live: "https://gameoflifevisualization.netlify.app/",
  },
  {
    id: 5,
    name: "Zen-ui",
    imgUrl:
      "https://ik.imagekit.io/abcdefg/ProjectImages/buttons_tMoWax86s.jpeg?updatedAt=1635331715969",
    info: "A CSS Component Library",
    github: "https://github.com/Dev-kunal/Components-Library-ZenUi",
    live: "https://zenui.netlify.app/",
  },
  // {
  //   id: 2,
  //   name: "Zen Tech Store",
  //   imgUrl:
  //     "https://ik.imagekit.io/abcdefg/ProjectImages/techstore_0iUvPeeot.jpeg?updatedAt=1635148380934",
  //   info: "An E-Comm app for Tech products",
  //   github: "https://github.com/Dev-kunal/EcommerceApp-Zen-TechStore",
  //   live: "https://zen-tech-store.netlify.app",
  // },
  // {
  //   id: 4,
  //   name: "Quizzy",
  //   imgUrl:
  //     "https://ik.imagekit.io/abcdefg/ProjectImages/quizzy_3g0dS4XCjn.jpeg?updatedAt=1635331501993",
  //   info: "A Quiz app build using Typescript",
  //   github: "https://github.com/Dev-kunal/Quiz-App",
  //   live: "https://zen-quizzy.netlify.app/",
  // },
  // {
  //   id: 3,
  //   name: "TechTube",
  //   imgUrl:
  //     "https://ik.imagekit.io/abcdefg/ProjectImages/techtube_KYGzhy_IXsP.jpeg?updatedAt=1635148381939",
  //   info: "A Tech Video Library app",
  //   github: "https://github.com/Dev-kunal/VideoLibrary-TechTube",
  //   live: "https://tech-tube.netlify.app/",
  // },
  // {
  //   id: 1,
  //   name: "Social Monks",
  //   imgUrl:
  //     "https://ik.imagekit.io/abcdefg/ProjectImages/socialmonks_5pJgIVgXBGCw.jpeg?updatedAt=1635149694175",
  //   info: "A Social Media app for minimialist's",
  //   github: "https://github.com/Dev-kunal/Social-Monks",
  //   live: "https://social-monks.netlify.app",
  // },
];

export const blogsData = [
  {
    id: 1,
    headerUrl:
      "https://cdn.hashnode.com/res/hashnode/image/upload/v1626585311370/u4HhHzhgvk.png?w=1600&h=840&fit=crop&crop=entropy&auto=compress,format&format=webp",
    title: "How JavaScipt works and executes your program under the hood",
    date: "Aug 5, 2021",
    url: "https://kunal-tijare.hashnode.dev/how-javascipt-works-and-executes-your-program-under-the-hood",
  },
  {
    id: 2,
    headerUrl:
      "https://cdn.hashnode.com/res/hashnode/image/upload/v1626612589184/21mAd6Wiz.png?w=1600&h=840&fit=crop&crop=entropy&auto=compress,format&format=webp",
    title: "Scope, Lexical Environment, and Scope Chain in JavaScript",
    date: "Aug 9, 2021",
    url: "https://kunal-tijare.hashnode.dev/scope-lexical-environment-and-scope-chain-in-javascript",
  },
  {
    id: 3,
    headerUrl:
      "https://cdn.hashnode.com/res/hashnode/image/upload/v1626597979516/YI3YWAp7v.png?w=1600&h=840&fit=crop&crop=entropy&auto=compress,format&format=webp",
    title: "Hoisting in JavaScript, ( in the easiest way )",
    date: "Aug 10, 2021",
    url: "https://kunal-tijare.hashnode.dev/hoisting-in-javascript-in-the-easiest-way",
  },
];

export const skillsData = [
  {
    label: "ReactJs",
    icon: "https://d26c7l40gvbbg2.cloudfront.net/tool_icons/reactjs.svg",
  },
  {
    label: "NextJs",
    icon: "https://d26c7l40gvbbg2.cloudfront.net/tool_icons/nextjs.svg",
  },
  {
    label: "GraphQl",
    icon: "https://d26c7l40gvbbg2.cloudfront.net/tool_icons/graphql.svg",
  },
  {
    label: "NodeJs",
    icon: "https://d26c7l40gvbbg2.cloudfront.net/tool_icons/nodejs.svg",
  },
  {
    label: "Express",
    icon: "https://d26c7l40gvbbg2.cloudfront.net/tool_icons/express.svg",
  },

  {
    label: "MongoDb",
    icon: "https://d26c7l40gvbbg2.cloudfront.net/tool_icons/mongodb.svg",
  },

  {
    label: "PostgreSQL",
    icon: "https://d26c7l40gvbbg2.cloudfront.net/tool_icons/postgresql.svg",
  },

  {
    label: "Javsscript",
    icon: "https://d26c7l40gvbbg2.cloudfront.net/tool_icons/javascript.svg",
  },
  {
    label: "HTML",
    icon: "https://d26c7l40gvbbg2.cloudfront.net/tool_icons/html.svg",
  },

  {
    label: "CSS",
    icon: "https://d26c7l40gvbbg2.cloudfront.net/tool_icons/css.svg",
  },
  {
    label: "TailwindCSS",
    icon: "https://d26c7l40gvbbg2.cloudfront.net/tool_icons/tailwindcss.svg",
  },
  {
    label: "Bootstrap",
    icon: "https://d26c7l40gvbbg2.cloudfront.net/tool_icons/bootstrap.svg",
  },
];
